import BaseContentDetailsPageNavView from "scripts/views/baseContentDetailsPageNavView";
import templateContentDetailsDocumentPageNav from "templates/contentDetailsDocumentPageNav.hbs";
import L from "lodash/fp";

class ContentDetailsDocumentPageNavView extends BaseContentDetailsPageNavView {
  constructor(options) {
    super(options);
    this.organizationProperties = options.organizationProperties;
  }

  get template() {
    return templateContentDetailsDocumentPageNav;
  }

  render() {
    const modelProps = this.model.toJSON();

    this.$el.html(
        this.template(
            L.merge(
                {
                  showComments: !this.organizationProperties.hideCommentsTab
                },
                modelProps,
            ),
        ),
    );

    this.updateLinkState();
    this.updatePosition();

    return this;
  }
}

export default ContentDetailsDocumentPageNavView;
